import React, { Component } from 'react';
import ValidationText from '../../utils/validation/ValidationText.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import { FinancealYearStartDateEndDate } from '../../utils/FinancialYearStartDateEndDate.js';
import { printFunction } from '../../components/print/printTemplate.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';

class GroupWiseAccountSummary extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            companyName: '',
            tableStatus: "",
            groupWiseAccoutList: [],
            accountGroupList: [],
            filterDetails: {
                group: "all",
                startDate: "",
                endDate: "",
                onlyBalTraAccount: "",
                totalCloseBal: "",
                totalCredit: "",
                totalDebit: "",
                totalOpenBal: "",

            },
            groupWiseAccountSummaryList: [],
            groupList: [
                { group: "All", value: "all" },
                { group: "Invoice Date", value: "invoiceDate" },
                { group: "Party Name", value: "partyname" },
                { group: "Net Amount", value: "netAmount" },
            ],
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endDate = dates.endDate
        this.setState({ filterDetails: filterDetails })
        this.getAllAccountGroups()
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    getAllAccountGroups = () => {
        this.commonServices.getAllAccountGroups().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    group: item.accountGroupname,
                    value: item.accountGroupCode,
                }));
                this.setState({ accountGroupList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.group = "all"
        Fdetails.endDate = ""
        Fdetails.onlyBalTraAccount = ""
        Fdetails.totalCloseBal = ""
        Fdetails.totalCredit = ""
        Fdetails.totalDebit = ""
        Fdetails.totalOpenBal = ""
        this.setState({
            filterDetails: Fdetails, noItemFound: "", groupWiseAccoutList: []
        });
    }
    getAllGroupWiseAccountSummary = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ tableStatus: "Loading..." }, () => {
                let request = this.state.filterDetails
                this.accountServices.getAllGroupWiseAccountSummary(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({ groupWiseAccoutList: response.responseData }, () => {
                            let totalOpeningBalance = 0;
                            let totalDebitAmount = 0;
                            let totalCreditAmount = 0;
                            let totalClosingBalance = 0;

                            this.state.groupWiseAccoutList.forEach((party) => {
                                totalOpeningBalance += party.openingBalance * (party.openingBalanceDRCR === "Dr" ? -1 : 1);
                                totalDebitAmount += party.debitAmount;
                                totalCreditAmount += party.creditAmount;
                                totalClosingBalance += party.closingBalance * (party.closingBalanceDRCR === "Dr" ? -1 : 1);
                            });

                            let totalOpeningBalanceDRCR = totalOpeningBalance >= 0 ? "Cr" : "Dr";
                            let totalClosingBalanceDRCR = totalClosingBalance >= 0 ? "Cr" : "Dr";

                            // Convert to absolute values for display
                            totalOpeningBalance = Math.abs(totalOpeningBalance);
                            totalClosingBalance = Math.abs(totalClosingBalance);

                            let details = this.state.filterDetails
                            details.totalOpenBal = totalOpeningBalance + ' ' + totalOpeningBalanceDRCR
                            details.totalDebit = totalDebitAmount + ' ' + 'Dr'
                            details.totalCredit = totalCreditAmount + ' ' + 'Cr'
                            details.totalCloseBal = totalClosingBalance + ' ' + totalClosingBalanceDRCR
                            this.setState({ filterDetails: details })
                        })
                    } else {
                        this.setState({ tableStatus: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details });
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details });
    };
    handleCheckbox = (e, name) => {
        let details = this.state.filterDetails;
        details[name] = !details.onlyBalTraAccount;
        this.setState({ filterDetails: details });
    };

    render() {
        return (
            <div className='GroupWiseAccountSummary-page'>
                <div className="item-search flex gap-2.5 !mb-3">
                    <div className="search-grp w-[20%]">
                        <label>Group</label>
                        <select
                            name="group"
                            className="w-full"
                            value={this.state.filterDetails.group
                                && this.state.filterDetails.group !== 'all'
                                && this.state.accountGroupList.find((party) => party.value === this.state.filterDetails.group).value}
                            onChange={(event) =>
                                this.handleDropDownChange(
                                    event,
                                    "group",
                                    "filterDetails"
                                )
                            }
                        >
                            <option value='all'>All</option>
                            {this.state.accountGroupList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.group}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="input-grp  w-[20%]" >
                        <label>Start Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp w-[20%]">
                        <label>End Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endDate}
                        /> */}
                    </div>
                    <div className="btn-grp mt-auto">
                        <button
                            className={`add-btn mt-auto`}
                            onClick={() => this.getAllGroupWiseAccountSummary()}
                        > Search
                        </button>

                        <button
                            className={`cancel-btn  mt-auto`}
                            onClick={() => this.resetForm()}
                        >cancel
                        </button>
                        <button
                            className="print-btn mt-auto"
                            disabled={this.state.groupWiseAccoutList.length > 0 ? false : true}
                            onClick={() => printFunction()}
                        >
                            Print
                        </button>

                        {this.state.groupWiseAccountSummaryList > 0 ?
                            <button
                                className={`print-btn  mt-auto`}
                                onClick={() => this.resetForm()}
                            >Print
                            </button> : null}
                    </div>
                </div>
                {/* <div className="input-grp flex items-center mb-3">
                    <input
                        className="inputFocus mr-[8px] !w-[18px] h-[18px]"
                        type="checkbox"
                        name="onlyBalTraAccount"
                        id="onlyBalTraAccount"
                        autocomplete="off"
                        disabled={this.state.filterDetails.search === "stock"}
                        value={this.state.filterDetails.onlyBalTraAccount}
                        checked={this.state.filterDetails.onlyBalTraAccount}
                        onChange={(event) =>
                            this.handleCheckbox(event, "onlyBalTraAccount")
                        }
                    />
                    <label className="!mb-0">Only Balance / Transaction a/c</label>
                </div> */}
                <div class="item-listing">
                    <div class="itemList-table ">
                        <div class="table-container" style={{ height: "calc(100vh - 220px)" }} >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[35%]'>Account Name</td>
                                        <td className='w-[25%]'>Group Name</td>
                                        <td className='w-[10%]'>Open. Bal.</td>
                                        <td className='w-[10%]'>Debit</td>
                                        <td className='w-[10%]'>Credit</td>
                                        <td className='w-[10%]'>Clos. Bal.</td>

                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.groupWiseAccoutList && this.state.groupWiseAccoutList.length > 0 ? (
                                        this.state.groupWiseAccoutList.map((details, key) => (
                                            <tr
                                                key={key}
                                                className="hover:bg-gray-200"
                                            >
                                                <td>
                                                    {/* <input
                                                        className="inputFocus mr-[8px] !w-[18px] h-[18px]"
                                                        type="checkbox"
                                                        name="tableCheckBox"
                                                        id="tableCheckBox"
                                                        autocomplete="off"
                                                        value={this.state.filterDetails.tableCheckBox}
                                                        checked={this.state.filterDetails.tableCheckBox}
                                                        onChange={(event) =>
                                                            this.handleCheckbox(event, "tableCheckBox")
                                                        } /> */}
                                                    {details.partyName}</td>
                                                <td>{details.accountGroupname ? details.accountGroupname : ''}</td>
                                                <td>{details.openingBalance + ' ' + details.openingBalanceDRCR}</td>
                                                <td>{details.debitAmount + ' ' + details.debitAmountDRCR}</td>
                                                <td>{details.creditAmount + ' ' + details.creditAmountDRCR}</td>
                                                <td>{details.closingBalance + ' ' + details.closingBalanceDRCR}</td>
                                            </tr>
                                        ))
                                    ) : this.state.groupWiseAccoutList
                                        && this.state.groupWiseAccoutList.length === 0
                                        && this.state.tableStatus !== "" ? (
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.tableStatus}
                                            </td>
                                        </tr>
                                    ) : this.state.groupWiseAccoutList
                                        && this.state.groupWiseAccoutList.length === 0
                                        && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <div className="item-sections w-[60%] rounded-[10px]  ml-auto mt-3 !p-3  !bg-white " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                    <div className='flex gap-2.5 '>
                        <div className=" w-full">
                            <label>Total Open. Bal</label>
                            <input
                                className='h-[36px]'
                                type="text"
                                id="totalOpenBal"
                                name="totalOpenBal"
                                autocomplete="off"
                                disabled
                                value={this.state.filterDetails.totalOpenBal}

                            />
                        </div>
                        <div className=" w-full">
                            <label>Total Debit</label>
                            <input
                                className='h-[36px]'
                                type="text"
                                id="totalDebit"
                                name="totalDebit"
                                autocomplete="off"
                                disabled
                                value={this.state.filterDetails.totalDebit}

                            />
                        </div>
                        <div className=" w-full">
                            <label>Total Credit</label>
                            <input
                                className='h-[36px]'
                                type="text"
                                id="totalCredit"
                                name="totalCredit"
                                autocomplete="off"
                                disabled
                                value={this.state.filterDetails.totalCredit}

                            />
                        </div>
                        <div className=" w-full">
                            <label>Total Clos. Bal.</label>
                            <input
                                className='h-[36px]'
                                type="text"
                                id="totalCloseBal"
                                name="totalCloseBal"
                                autocomplete="off"
                                disabled
                                value={this.state.filterDetails.totalCloseBal}

                            />
                        </div>
                    </div>

                </div>

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Material Requirment Report [PM]</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            Start Date: <strong>{this.state.filterDetails.startDate}</strong><br />
                                            End Date: <strong>{this.state.filterDetails.endDate}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                                                              <div>
                                                                                <span className="info-label">Item Name:</span>
                                                                                <p className="info-value">Paracetamol</p>
                                                                              </div>
                                                                            </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "25%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Account Name
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Group Name
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Opening Balance
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Debit
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Credit
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Closing Balance
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.groupWiseAccoutList && this.state.groupWiseAccoutList.length > 0 ?
                                    this.state.groupWiseAccoutList.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.partyName}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.accountGroupname ? details.accountGroupname : ''}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.openingBalance + ' ' + details.openingBalanceDRCR}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.debitAmount + ' ' + details.debitAmountDRCR}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.creditAmount + ' ' + details.creditAmountDRCR}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.closingBalance + ' ' + details.closingBalanceDRCR}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                            <tfoot>
                                <tr style={{ backgroundColor: '#f5f5f5' }}>
                                    <td colSpan="2" style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                        <span style={{ fontSize: "7px", color: "#444", fontWeight: "500", lineHeight: "12px" }}>Total</span>
                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {this.state.filterDetails.totalOpenBal}
                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {this.state.filterDetails.totalDebit}
                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {this.state.filterDetails.totalCredit}
                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {this.state.filterDetails.totalCloseBal}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GroupWiseAccountSummary;